import { useResource } from '@landsbankinn/l16n';
import { Dropdown, useInputValidation } from '@landsbankinn/ui';
import { set, isSameDay } from 'date-fns';
import React, { useMemo } from 'react';
import type { availableDatesAndTimes_node_ServiceLocation } from '../../../../graphql/Appointment/__generated__/availableDatesAndTimes';
import { useAppointmentContext } from '../../../book-appointment/BookAppointment';
import res from './SelectDateAndTime.res';

interface IProps {
  data: availableDatesAndTimes_node_ServiceLocation;
  setSelectedTime: React.Dispatch<React.SetStateAction<number>>;
  selectedTime?: number;
}

export function TimeDropdown({ data, selectedTime, setSelectedTime }: IProps) {
  const { dispatch, state } = useAppointmentContext();
  const { r } = useResource();

  const timeOptions = useMemo(() => {
    if (state.date && data) {
      const selectedDay = data.availableAppointments?.find((i) =>
        isSameDay(new Date(i.date), state.date as Date),
      );

      if (selectedDay) {
        return selectedDay.time.map((time, index) => ({
          label: time,
          value: index,
        }));
      }
    }
    return [];
  }, [state.date, data]);

  const [ref, isValid] = useInputValidation(selectedTime, [
    {
      validation: (value) => value !== undefined,
    },
  ]);

  return (
    <Dropdown
      buildOption={(op) => op}
      value={
        timeOptions && selectedTime ? timeOptions[selectedTime] : undefined
      }
      variant="noBorder"
      labelVariant="aboveInput"
      errorMessageVariant="insideInput"
      isValid={isValid}
      label={r(res.pickTime)}
      isDisabled={false}
      onChange={(item) => {
        if (state.date) {
          const [hour, minute] =
            timeOptions[Number((item as any)['value'])].label.split(':');
          dispatch?.({
            type: 'selectDateAndTime',
            date: set(state.date, {
              hours: Number(hour),
              minutes: Number(minute),
            }),
          });
        }
        setSelectedTime(Number((item as any)['value']));
      }}
      options={timeOptions}
    />
  );
}
